import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "@/contexts/AuthContext";
import { PostHogProvider } from "@/lib/posthog/client";
import { PostHogUserIdentifier } from "@/components/posthog-user-identifier";
import { PostHogSync } from "@/components/posthog-sync";
import { ThemeProvider } from "@/components/theme-provider";
import { router } from "@/router";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 1,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeProvider
      attribute="class"
      defaultTheme="light"
      enableSystem
      disableTransitionOnChange
    >
      <PostHogProvider>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <PostHogUserIdentifier />
            <PostHogSync />
            <Suspense
              fallback={
                <div className="min-h-screen bg-background flex items-center justify-center">
                  <div className="flex flex-col items-center space-y-4">
                    <div className="animate-spin rounded-full size-12 border-b-2 border-primary"></div>
                    <p className="text-muted-foreground">Loading page...</p>
                  </div>
                </div>
              }
            >
              <RouterProvider router={router} />
            </Suspense>
          </AuthProvider>
        </QueryClientProvider>
      </PostHogProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
